import { CardLinksFields, CardLinkProps } from "../types/CardLink.types";

export class CardLinkModel {
  public readonly fields?: CardLinksFields;

  constructor(props: CardLinkProps) {
    this.fields = props.fields;
  }
}
